import { fmtDateTime } from "../api";
import { TIMELINE_TIPI } from "../labels";
import { Phone, Mail, MessageCircle, StickyNote, Globe, Eye, Users, Cog, KeyRound, Euro, Link2, CheckSquare } from "lucide-react";

const ICONS = { chiamata: Phone, email: Mail, whatsapp: MessageCircle, sms: MessageCircle, nota: StickyNote, incontro: Users, visita: Eye,
  richiesta_sito: Globe, sistema: Cog, chiavi: KeyRound, prezzo: Euro, abbinamento: Link2, attivita: CheckSquare, pubblicazione: Globe };
const LABEL = { ...TIMELINE_TIPI, richiesta_sito: "Richiesta dal sito", sistema: "Sistema", chiavi: "Chiavi", prezzo: "Prezzo", abbinamento: "Abbinamento", attivita: "Attività", pubblicazione: "Pubblicazione" };

export default function Timeline({ items, testid = "timeline" }) {
  if (!items?.length) return <p className="text-sm text-anthracite/45">Nessuna attività registrata.</p>;
  return (
    <ol className="relative border-l border-border-subtle ml-3 space-y-5" data-testid={testid}>
      {items.map((e) => {
        const Icon = ICONS[e.tipo] || Cog;
        return (
          <li key={e.id} className="ml-5" data-testid={`${testid}-item`}>
            <span className="absolute -left-3 grid place-items-center h-6 w-6 rounded-full bg-white border border-border-subtle"><Icon className="h-3 w-3 text-brand" /></span>
            <p className="text-xs text-anthracite/45">{fmtDateTime(e.at)} · {LABEL[e.tipo] || e.tipo} · {e.userNome || "Sistema"}</p>
            <p className="text-sm mt-0.5 whitespace-pre-line">{e.testo}{e.esito ? ` — Esito: ${e.esito}` : ""}</p>
          </li>
        );
      })}
    </ol>
  );
}
